import { useEffect } from 'react';

// This is an aprox. chart width to fit an A4 page considering
// paddings / margins we have in our pages
const PRINT_CHART_WIDTH = 650;

/**
 * Resizes a hightcharts Chart to fit in the print layout.
 * @param {Object} chartRef - A react's ref pointing to hightcharts chart
 * @param {Number} height - The chart original height
 */
const useChartPrint = (chartRef, height) => {
  useEffect(() => {
    const handleBeforePrint = () => {
      if (chartRef && chartRef.current) {
        const {
          current: { chart },
        } = chartRef;

        chart.resetParams = [chart.chartWidth, chart.chartHeight, false];
        chart.setSize(PRINT_CHART_WIDTH, height, false);
      }
    };

    const handleAfterPrint = () => {
      if (chartRef && chartRef.current) {
        const {
          current: { chart },
        } = chartRef;

        // Next tick is needed for hightcharts to restore properly
        setTimeout(() => {
          chart.setSize(...chart.resetParams);
          chart.reflow();
        });
      }
    };

    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint);
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, []);
};

export default useChartPrint;
